import React, { useState } from 'react';
import { Form, Input, Button, Card, Alert, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

const { Title } = Typography;

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            setErrorMsg('');
            const response = await axios.post(`${config.apiUrl}/api/v1/forgot-password`, {
                email: values.email
            });

            if (response.data.success) {
                setEmailSent(true);
            } else {
                setErrorMsg(response.data.message || 'Không thể gửi email đặt lại mật khẩu!');
            }
        } catch (error) {
            if (error.response?.data?.error_code === 'USER_NOT_FOUND') {
                console.log('Forgot password: email not found -', values.email);
                setErrorMsg('Email không tồn tại trên hệ thống, vui lòng kiểm tra lại!');
            } else {
                console.error('Forgot password error:', error);
                setErrorMsg(
                    error.response?.data?.message ||
                    'Có lỗi xảy ra. Vui lòng thử lại!'
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const validateEmail = (_, value) => {
        if (!value) {
            return Promise.reject('Vui lòng nhập email!');
        }

        // Remove extra spaces
        value = value.trim();

        // Basic email format validation
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(value)) {
            return Promise.reject('Email không đúng định dạng!');
        }

        // Maximum length validation
        if (value.length > 255) {
            return Promise.reject('Email không được vượt quá 255 ký tự!');
        }

        // Domain validation (optional - customize as needed)
        // const domain = value.split('@')[1];
        // const allowedDomains = ['utt.edu.vn', 'gmail.com']; // Add your allowed domains
        // if (!allowedDomains.includes(domain)) {
        //     return Promise.reject('Email phải thuộc domain được cho phép!');
        // }

        // No consecutive dots
        if (value.includes('..')) {
            return Promise.reject('Email không được chứa dấu chấm liên tiếp!');
        }

        // Check for valid characters in local part
        const localPart = value.split('@')[0];
        if (!/^[a-zA-Z0-9._-]+$/.test(localPart)) {
            return Promise.reject('Email chỉ được chứa chữ cái, số và các ký tự . _ -');
        }

        return Promise.resolve();
    };

    const renderSuccessMessage = () => (
        <div style={{ textAlign: 'center' }}>
            <Title level={3}>Email đã được gửi!</Title>
            <p>Vui lòng kiểm tra hộp thư của bạn và làm theo hướng dẫn để đặt lại mật khẩu.</p>
            <Button type="primary" onClick={() => navigate('/login')}>
                Quay lại trang đăng nhập
            </Button>
        </div>
    );

    const renderForm = () => (
        <>
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <Title level={2}>Quên mật khẩu</Title>
                <p>Nhập email của bạn để nhận hướng dẫn đặt lại mật khẩu</p>
            </div>

            {errorMsg && (
                <Alert
                    message={errorMsg}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                />
            )}

            <Form
                name="forgot-password"
                onFinish={onFinish}
                layout="vertical"
                requiredMark={false}
            >
                <Form.Item
                    name="email"
                    rules={[
                        { validator: validateEmail },
                        { help: 'Vui lòng sử dụng email hợp lệ để nhận hướng dẫn đặt lại mật khẩu' }
                    ]}
                >
                    <Input 
                        prefix={<MailOutlined />}
                        placeholder="Email"
                        size="large"
                        maxLength={255}
                    />
                </Form.Item>

                <Form.Item>
                    <Button 
                        type="primary" 
                        htmlType="submit" 
                        loading={loading}
                        block
                        size="large"
                    >
                        Gửi yêu cầu
                    </Button>
                </Form.Item>

                <div style={{ textAlign: 'center' }}>
                    <Link to="/login">Quay lại đăng nhập</Link>
                </div>
            </Form>
        </>
    );

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '100vh',
            background: '#f0f2f5' 
        }}>
            <Card style={{ 
                width: '100%', 
                maxWidth: 400,
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}>
                {emailSent ? renderSuccessMessage() : renderForm()}
            </Card>
        </div>
    );
};

export default ForgotPassword; 